import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import IUser from '../models/user';

export const useAuthStore = create<{
  access_token: string | null;
  user: IUser | null;
  setAuth: (token: string, user: any) => void;
  isAuthenticated: () => boolean;
  logout: () => void;
}>()(
  devtools(
    persist(
      (set, get) => ({
        access_token: null,
        user: null,
        setAuth: (token: string, user: any) => set({ access_token: token, user }),
        isAuthenticated: () => !!get().access_token,
        logout: () => set({ access_token: null, user: null }),
      }),
      {
        name: 'auth-storage',
      }
    )
  )
);

export function isLogged() {
  return useAuthStore.getState().isAuthenticated();
}